import { render, staticRenderFns } from "./CustomerSupport.vue?vue&type=template&id=4bdc254a"
import script from "./CustomerSupport.vue?vue&type=script&lang=js"
export * from "./CustomerSupport.vue?vue&type=script&lang=js"
import style0 from "./CustomerSupport.vue?vue&type=style&index=0&id=4bdc254a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports